import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  SystemCodeToJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface UserNote {
  id: number
  date: string
  place: SystemCode
  note: string
  revision: number
  _delete: boolean
}

export function UserNoteFromJSON(json: any): UserNote {
  return {
    id: json.id,
    date: exists(json, 'date') ? dateToPlainFormat(json.date) : '',
    place: exists(json, 'place')
      ? SystemCodeFromJSON(json.place)
      : defaultSystemCode(),
    note: exists(json, 'note') ? json.note : '',
    revision: json.revision,
    _delete: false
  }
}

export function UserNoteToJSON(value: UserNote): any {
  return {
    id: value.id,
    date: value.date,
    place: SystemCodeToJSON(value.place),
    note: value.note,
    revision: value.revision,
    _delete: value._delete
  }
}

export const defaultUserNote = (): UserNote => ({
  id: 0,
  date: '',
  place: defaultSystemCode(),
  note: '',
  revision: 1,
  _delete: false
})
